import {createContext} from 'react';
import {AsyncSearchModel, AsyncSearchState, SearchProgressStage} from '@features/search/interfaces';

export const SearchContext = createContext<AsyncSearchModel>({
    state: AsyncSearchState.None,
    length: 0,
    progressStage: SearchProgressStage.None,
    showResults: () => {}
});
